import { http } from './http'

export type ImageConfig =
  | 'NaN'
  | 'ARTIST'
  | 'STAGE'
  | 'NEWS'
  | 'NEWS_THUMBNAIL'
  | 'LOCATION_TYPE_LOGO'
  | 'LOCATION_TYPE_FILTER_LOGO'
  | 'PHOTO_GALLERY'
  | 'INFO'
  | 'MEMORY'
  | 'MEMORY_COVER'
  | 'MEMORY_COVER_INTRO_LOGO_MARK'
  | 'SETTINGS_TOP_UP_DONATE_BANNER'
  | 'SETTINGS_FRIENDS_WIDGET'
  | 'SETTINGS_FOOTER_BANNER'
  | 'SEO_SETTINGS_DEFAULT_META'
  | 'DEFAULT_IMAGE_SOCIAL_SHARE'
  | 'DEFAULT_IMAGE_HERO'
  | 'DEFAULT_IMAGE_ARTIST'
  | 'DEFAULT_IMAGE_NEWS'
  | 'DEFAULT_IMAGE_VIDEO_GALLERY'
  | 'DEFAULT_IMAGE_INFO'
  | 'DEFAULT_IMAGE_STAGES_LOGO'
  | 'DEFAULT_IMAGE_CHECK_IN'
  | 'GROUP_CONFIG_CURRENCY'
  | 'PARTNERS_LOGO'
  | 'SETTINGS_THEME_LOGO_DARK'
  | 'SETTINGS_THEME_LOGO_LIGHT'
  | 'SETTINGS_THEME_FAVICON'
  | 'SETTINGS_THEME_PHONE'
  | 'SETTINGS_THEME_RADIO_DARK'
  | 'SETTINGS_THEME_RADIO_LIGHT'
  | 'SETTINGS_THEME_SQUARE_MARK_DARK'
  | 'SETTINGS_THEME_SQUARE_MARK_LIGHT'
  | 'SETTINGS_THEME_EMAIL'
  | 'VENDOR_PRODUCT'
  | 'GAMIFICATION_REWARD'
  | 'GAMIFICATION_STEP_ICON'
  | 'GAMIFICATION_ROADMAP_LOGO'
  | 'GAMIFICATION_AVATAR_OPTION'
  | 'GAMIFICATION_RANK'

export const uploadImages = async (
  file: File,
  isPublic = true,
  imageConfig: ImageConfig,
) => {
  const formData = new FormData()
  formData.append('photo', file)
  return http.post<{
    photoKey: string
    photoUrl: string
  }>(`/operations/upload`, formData, {
    params: {
      public: isPublic,
      imageConfig: imageConfig === 'NaN' ? null : imageConfig,
    },
  })
}

export const uploadNonPublicImage = async (file: File) => {
  const formData = new FormData()
  formData.append('photo', file)
  return http.post<{
    photoKey: string
    photoUrl: string
  }>(`/operations/upload`, formData, {
    params: {
      public: false,
    },
  })
}

export const uploadImage = async (
  file: File,
  setIsUploading: (u: boolean) => void,
  setIsError: (e: boolean) => void,
  setShowMessageBox: (s: boolean) => void,
  setMessage: (s: string) => void,
  setIsErrorRatio: (s: boolean) => void,
  imageConfig: ImageConfig,
  isPublic = true,
) => {
  setIsUploading(true)
  try {
    const { data, status } = await uploadImages(file, isPublic, imageConfig)
    if (status === 200) {
      setIsErrorRatio(false)
    }
    return { photoKey: data.photoKey, photoUrl: data.photoUrl }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (e.response) {
      if (e.response.status === 400) {
        setIsErrorRatio(true)
      } else {
        setIsError(true)
        setShowMessageBox(true)
        setMessage(e.message)
      }
    } else {
      console.error(e)
    }
    return { photoKey: '', photoUrl: '' }
  } finally {
    setIsUploading(false)
  }
}
